import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { undo_0 } from 'owa-locstrings/lib/strings/undo_0.locstring.json';
import {
    DefaultHotKeyCommand,
    lazyShowCalendarNotification,
    NotificationBarCallbackReason,
} from 'owa-calendar-notification-bar';

/**
 * Shows a notification telling the user they can undo the delete action
 * @returns a promise that resolves true if the user wants to undo, false if the notification is dismissed for any other reason
 */
export default function showUndoNotificationForDelete(
    actionName: string,
    messageString: string
): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
        lazyShowCalendarNotification.import().then(showCalendarNotification => {
            showCalendarNotification(
                actionName,
                'Surface',
                messageString,
                {
                    icon: ControlIcons.Delete,
                    primaryActionHotKeyCommand: DefaultHotKeyCommand.Undo,
                },
                {
                    primaryActionText: loc(undo_0),
                    notificationCallback: reason => {
                        if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    },
                }
            );
        });
    });
}
